import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const BankConfigurationBasicInfoComponent = ({
    selectBankConfigurations, handleInnerFormChange, ledgersList,
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Ledger Name"
                            labelField="LedgerName"
                            list={ledgersList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'LedgerId'
                                )
                            }}
                            optionName='Choose Ledger Name'
                            type="select"
                            value={selectBankConfigurations?.LedgerId}
                            valueField="LedgerId"
                        />
                        <InputContainer
                            label="Cheque Book Name"
                            labelField="ChequeBookName"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ChequeBookName'
                                );
                            }}
                            type="text"
                            value={selectBankConfigurations?.ChequeBookName}
                        />
                        <InputContainer
                            label="Starting Number"
                            labelField="StartingNumber"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'StartingNumber'
                                );
                            }}
                            type="text"
                            value={selectBankConfigurations?.StartingNumber}
                        />
                        <InputContainer
                            label="End Number"
                            labelField="EndNumber"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'EndNumber'
                                );
                            }}
                            type="text"
                            value={selectBankConfigurations?.EndNumber}
                        />
                        <InputContainer
                            label="No Of Leaves"
                            labelField="NoOfLeaves"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'NoOfLeaves'
                                );
                            }}
                            type="number"
                            value={selectBankConfigurations?.NoOfLeaves}
                        />
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Informations"
            />
        </>
    )
}
export default BankConfigurationBasicInfoComponent;
